export const appName = 'references';
